import React from 'react';
import usePreview3DStore from '../store';
import { EmptySceneData } from './emptySceneData';
import { ExistingSceneData } from './existingSceneData';

export const LoadSceneData = ({ children, onSceneLoaded }: { children: React.ReactNode; onSceneLoaded: (isNew: boolean) => void }) => {
    const [zkProduct] = usePreview3DStore((store) => [store.zkProduct]);

    if (zkProduct && zkProduct.get('scenes').length > 0 && zkProduct.get('scenes').at(0).get('sceneID')) {
        return <ExistingSceneData onSceneLoaded={onSceneLoaded}>{children}</ExistingSceneData>;
    }

    return <EmptySceneData onSceneLoaded={onSceneLoaded}>{children}</EmptySceneData>;
};
